import { requestMyManagerProfile, type ManagerProfileResponse, type ManagerRole } from '../api/managerApi';

const USER_DISPLAY_NAME_STORAGE_KEY = 'userDisplayName';
const USER_ROLE_STORAGE_KEY = 'userRole';

export async function loadUserDisplayName() {
  const profile = await loadMyManagerProfile();
  const displayName = profile.name ?? profile.account;

  sessionStorage.setItem(USER_DISPLAY_NAME_STORAGE_KEY, displayName);

  return displayName;
}

export function loadMyManagerProfile(): Promise<ManagerProfileResponse> {
  return requestMyManagerProfile().then((profile) => {
    sessionStorage.setItem(USER_ROLE_STORAGE_KEY, profile.role);

    return profile;
  });
}

export function getStoredUserDisplayName() {
  return sessionStorage.getItem(USER_DISPLAY_NAME_STORAGE_KEY);
}

export function clearStoredUserDisplayName() {
  sessionStorage.removeItem(USER_DISPLAY_NAME_STORAGE_KEY);
  sessionStorage.removeItem(USER_ROLE_STORAGE_KEY);
}

export function getStoredManagerRole(): ManagerRole | null {
  const role = sessionStorage.getItem(USER_ROLE_STORAGE_KEY);

  if (role === 'SUPER' || role === 'MIDDLE' || role === 'GENERAL' || role === 'NORMAL') {
    return role;
  }

  return null;
}
